(function () {
  var INLINE_MIN_WIDTH = 180; // below this, drop the search bar to its own row instead
  var ROW_MODE_CLASS = 'has-search-own-row';

  function positionSearch() {
    var search = document.querySelector('.header-livesearch .livesearch-form');
    var branding = document.querySelector('.branding');
    var tools = document.querySelector('.header-tools');
    var banner = document.querySelector('.header-cta-group');
    var header = document.querySelector('.main-header');
    if (!search || !branding || !tools) return;

    var headerHeight = header ? header.getBoundingClientRect().bottom + 10 : 82;

    if (window.innerWidth <= 720) {
      resetSearch(search);
      document.body.classList.remove(ROW_MODE_CLASS);
      document.documentElement.style.removeProperty('--search-own-row-space');
      return;
    }

    var brandingRect = branding.getBoundingClientRect();
    var toolsRect = tools.getBoundingClientRect();
    var bannerRect = banner ? banner.getBoundingClientRect() : null;
    var margin = 16;

    var rightBoundary = toolsRect.left;
    if (bannerRect && bannerRect.left < rightBoundary) {
      rightBoundary = bannerRect.left;
    }

    var inlineLeft = brandingRect.right + margin;
    var inlineWidth = rightBoundary - margin - inlineLeft;

    if (inlineWidth >= INLINE_MIN_WIDTH) {
      // Center the search bar vertically against the logo, rather than relying on
      // a hardcoded CSS top value that goes stale whenever the header height changes.
      var searchHeight = search.getBoundingClientRect().height || 34;
      var inlineTop = brandingRect.top + (brandingRect.height - searchHeight) / 2;
      search.style.setProperty('position', 'fixed', 'important');
      search.style.setProperty('top', inlineTop + 'px', 'important');
      search.style.setProperty('left', inlineLeft + 'px', 'important');
      search.style.setProperty('width', inlineWidth + 'px', 'important');
      search.style.setProperty('transform', 'none', 'important');
      search.style.removeProperty('display');
      document.body.classList.remove(ROW_MODE_CLASS);
      document.documentElement.style.removeProperty('--search-own-row-space');
      return;
    }

    // Not enough room beside the logo: drop to its own row below the header.
    // Align it to the same left margin as the logo/page content (not the raw
    // viewport center), since pages with a left sidebar (e.g. collection/home
    // pages) have their content column offset from the true viewport center.
    var rowLeft = brandingRect.left;
    var rowWidth = Math.min(480, window.innerWidth - rowLeft - margin);
    search.style.setProperty('position', 'fixed', 'important');
    search.style.setProperty('top', headerHeight + 'px', 'important');
    search.style.setProperty('left', rowLeft + 'px', 'important');
    search.style.setProperty('transform', 'none', 'important');
    search.style.setProperty('width', rowWidth + 'px', 'important');
    search.style.removeProperty('display');

    document.body.classList.add(ROW_MODE_CLASS);
    var searchBottom = search.getBoundingClientRect().bottom;
    var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    var extraSpace = Math.max(0, searchBottom - headerBottom + 16);
    document.documentElement.style.setProperty('--search-own-row-space', extraSpace + 'px');
  }

  function resetSearch(search) {
    search.style.removeProperty('position');
    search.style.removeProperty('top');
    search.style.removeProperty('left');
    search.style.removeProperty('width');
    search.style.removeProperty('transform');
    search.style.removeProperty('display');
  }

  window.addEventListener('load', positionSearch);
  window.addEventListener('resize', positionSearch);
  document.addEventListener('DOMContentLoaded', positionSearch);
  positionSearch();
})();
